<template>
    <div>
      <div class="avatar">
        <div class="avatarImg">
          <el-avatar style="width: 1.3rem;height: 1.3rem;line-height: 1.3rem" :src="$storage.get('circleUrl')"></el-avatar>
        </div>
        <div class="avatarName">{{$storage.get('name')}}</div>
      </div>
      <Menu src="static/img/jiuzhenrenguanli.png" text="健康卡管理" to-url="/personManage"></Menu>
      <Menu src="static/img/yuyueguahao.png" text="预约挂号" to-url="/registration"></Menu>
<!--      <Menu src="static/img/tijiantaocan.png" text="体检套餐" to-url="/medicalPlan"></Menu>-->
<!--      <Menu src="static/img/wenjuandaan.png" text="问卷答案" to-url="/answerList"></Menu>-->
      <Menu src="static/img/yuyuejilu.png" text="预约记录" to-url="/registrationRecord"></Menu>
      <Menu src="static/img/menzhenjiaofei.png" text="门诊缴费" to-url="/pay"></Menu>
      <Menu src="static/img/jiaoyijilu.png  " text="交易记录" to-url="/payRecord"></Menu>
      <Menu src="static/img/zhuyuanxinxi.png" text="住院信息" to-url="/hospitalInfo"></Menu>
      <Menu src="static/img/baogaochaxun.png" text="报告查询" to-url="/reportChange"></Menu>
      <Menu src="static/img/manyidudiaocha.png" text="满意度调查" to-url="/satisfactionSurvey"></Menu>
<!--      <Menu src="static/img/changjianwenti.png" text="常见问题"></Menu>-->
<!--      <Menu src="static/img/guanyuwomen.png" text="关于我们"></Menu>-->
<!--      <Menu src="static/img/fenxianghaoyou.png" text="分享好友"></Menu>-->
    </div>
</template>

<script>
  import Menu from '../common/Menu'
    export default {
      data(){
        return{
          code:''
        }
      },
      components:{
        Menu
      },
      created() {
        //修改标题
        document.title = '个人中心'
      },
      methods:{

     }
    }
</script>

<style scoped>
  .avatar{
    width: 100%;
    height: 3rem;
    background-image: url("/static/img/avatarImg.jpg");
  }

  .avatarImg{
    width: 100%;
    height: 1.8rem;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }
  .avatarName{
    color: #ffffff;
    font-size: .36rem;
    text-align: center;
    margin-top: .2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/index.vue